import React from 'react';
import './styles.css';

const Loader = ({ width = 50, height = 50 }) => {
  return (
    <div className="loading-container">
      <div className="spinner" style={{ width: width/4, height: height/4 }}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;